import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    padding: theme.spacing(3),
    background: '#f5f7fb',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.5),
  },
  heading: {
    color: '#202b45',
    fontSize: 23,
    lineHeight: 1.25,
    fontWeight: 700,
  },
  subtitle: {
    color: '#7b8498',
    fontSize: 12,
    marginTop: 5,
  },
  refreshButton: {
    textTransform: 'none',
    borderColor: '#d7deeb',
    color: '#42516b',
    background: '#fff',
    borderRadius: 8,
    padding: '6px 12px',
  },
  card: {
    height: 'auto',
    border: '1px solid #e7ebf3',
    borderRadius: 11,
    boxShadow: '0 2px 9px rgba(31, 45, 75, 0.035)',
    background: '#fff',
  },
  cardContent: {
    padding: theme.spacing(2.25),
    '&:last-child': {
      paddingBottom: theme.spacing(2.25),
    },
  },
  idpCard: {
    position: 'relative',
    overflow: 'hidden',
  },
  idpTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  idpIdentity: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
  iconBox: {
    width: 48,
    height: 48,
    minWidth: 48,
    borderRadius: 10,
    background: '#eef0ff',
    color: '#6554d9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  idpName: {
    fontSize: 16,
    lineHeight: 1.3,
    fontWeight: 700,
    color: '#27334b',
  },
  idpDescription: {
    color: '#8490a3',
    fontSize: 13,
    marginTop: 3,
  },
  liveChip: {
    background: '#e6f7ed',
    color: '#16834c',
    fontWeight: 700,
    fontSize: 11,
    height: 24,
  },
  inactiveChip: {
    background: '#fff0f1',
    color: '#c43d50',
    fontWeight: 700,
    fontSize: 11,
    height: 24,
  },
  neutralChip: {
    background: '#f0f2f6',
    color: '#667085',
    fontWeight: 600,
    fontSize: 11,
    height: 24,
  },
  idpDetails: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: theme.spacing(2),
    borderTop: '1px solid #edf0f5',
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(1.5),
    },
  },
  infoLabel: {
    color: '#8993a6',
    fontSize: 14,
    marginBottom: 5,
  },
  infoValue: {
    color: '#344054',
    fontSize: 15,
    fontWeight: 600,
    overflowWrap: 'anywhere',
  },
  reason: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1, 1.25),
    borderRadius: 7,
    background: '#fff8e8',
    color: '#946200',
    fontSize: 12,
  },
  statsGrid: {
    marginTop: theme.spacing(2),
  },
  statCard: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minHeight: 92,
    padding: theme.spacing(1.75),
  },
  statIcon: {
    width: 38,
    height: 38,
    minWidth: 38,
    borderRadius: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  statLabel: {
    color: '#7d879a',
    fontSize: 14,
    lineHeight: 1.4,
  },
  statValue: {
    color: '#26334b',
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 1.35,
    marginTop: 3,
    overflowWrap: 'anywhere',
  },
  section: {
    marginTop: theme.spacing(2.5),
  },
  sectionHeader: {
    marginBottom: theme.spacing(1.25),
  },
  sectionTitle: {
    color: '#27334b',
    fontSize: 16,
    fontWeight: 700,
  },
  sectionSubtitle: {
    color: '#8993a6',
    fontSize: 13,
    marginTop: 3,
  },
  authHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    marginBottom: theme.spacing(2),
  },
  authIcon: {
    width: 38,
    height: 38,
    minWidth: 38,
    borderRadius: 9,
    background: '#e7f7ed',
    color: '#159354',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  authName: {
    color: '#27334b',
    fontSize: 14,
    fontWeight: 700,
  },
  authGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(1.5),
    },
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1.75),
  },
  search: {
    width: 340,
    maxWidth: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  filter: {
    minWidth: 145,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  tableContainer: {
    border: '1px solid #edf0f5',
    borderRadius: 8,
    overflowX: 'auto',
  },
  table: {
    minWidth: 720,
  },
  tableHead: {
    background: '#f7f8fb',
    '& .MuiTableCell-head': {
      color: '#69758a',
      fontWeight: 700,
      fontSize: 11,
      textTransform: 'uppercase',
      letterSpacing: '0.35px',
      whiteSpace: 'nowrap',
      padding: '12px 15px',
      borderBottom: '1px solid #e9edf4',
    },
  },
  tableCell: {
    padding: '12px 15px',
    borderBottom: '1px solid #edf0f5',
    fontSize: 12,
    color: '#475467',
  },
  appName: {
    fontWeight: 700,
    color: '#29344b',
    fontSize: 12,
  },
  entityId: {
    maxWidth: 300,
    overflowWrap: 'anywhere',
    fontSize: 11,
    color: '#758197',
  },
  uuid: {
    display: 'block',
    color: '#a0a8b6',
    fontSize: 10,
    marginTop: 3,
    overflowWrap: 'anywhere',
  },
  empty: {
    padding: theme.spacing(4),
    textAlign: 'center',
    color: '#8490a3',
    fontSize: 12,
  },
  error: {
    padding: theme.spacing(2),
    color: '#b42318',
    background: '#fff0f0',
    borderRadius: 8,
    fontSize: 13,
  },
  tableFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    marginTop: theme.spacing(1.5),
  },
  footerText: {
    color: '#8a94a6',
    fontSize: 11,
  },
  noBorder: {
    border: 'none',
    '& .MuiDataGrid-root': { border: 'none' },
    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f7f8fb', fontWeight: 700 },
    '& .MuiDataGrid-row:hover': { backgroundColor: '#f5f7ff' },
  },
}));
